<div class="padding">
  <h1 class="left-box">{{ 'hubReportsGrid.hubReports' | transloco }}</h1>

  <mat-card>
    <mat-card-content>
      <lib-hub-reports-filter></lib-hub-reports-filter>
      @if (repo.resource$ | async; as data) {
      <div>
        <!-- <app-search-orders-filter></app-search-orders-filter> -->
        <div class="spacer-small"></div>
        <!-- Main hub reports table -->
        @if (data) {
        <div class="table-container">
          <!-- Conditional paginator at the top (show only when number of orders displayed is >= 50) -->
          @if (data.length >= 50) {
          <div>
            <mat-paginator [pageSize]="this.repo.pageSize$ | async" [length]="this.repo.resourceCount$ | async"
              [pageIndex]="this.repo.pageNum$ | async" [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons="true"
              (page)="page($event)"></mat-paginator>
            <div class="spacer-small"></div>
          </div>
          }
          <!-- End of conditional paginator at the top -->
          <!-- Orders table -->
          @if (data.length > 0) {
          <table mat-table matSort [dataSource]="data" multiTemplateDataRows class="mat-elevation-z0"
            (matSortChange)="sort($event)">
            <ng-container matColumnDef="reference">
              <th mat-header-cell *matHeaderCellDef mat-sort-header id="reference"> {{ 'common.labels.reference' | transloco }} </th>
              <td mat-cell *matCellDef="let envelope"> {{ getReference(envelope) }} </td>
            </ng-container>

            <!-- Removing this for now, but will likely bring it back at some point with better logic/statuses -->
            <!-- <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef mat-sort-header id="status"> Status </th>
              <td mat-cell *matCellDef="let envelope"> {{ getStatus(envelope) }} </td>
            </ng-container> -->

            <ng-container matColumnDef="numOrders">
              <th mat-header-cell *matHeaderCellDef mat-sort-header id="numOrders"> {{ 'hubReportsGrid.ofOrders' | transloco }}
              </th>
              <td mat-cell *matCellDef="let envelope"> {{ envelope.envelopeOrders?.length ?? 0 }} </td>
            </ng-container>
            <ng-container matColumnDef="jurisdiction">
              <th mat-header-cell *matHeaderCellDef mat-sort-header id="jurisdiction"> {{ 'common.labels.jurisdiction' | transloco }}
              </th>
              <td mat-cell *matCellDef="let envelope">{{ getJurisdiction(envelope) }}
              <td>
            </ng-container>
            <ng-container matColumnDef="statusLastUpdated">
              <th mat-header-cell *matHeaderCellDef mat-sort-header id="statusLastUpdated"> {{ 'hubReportsGrid.updated' | transloco }} </th>
              <td mat-cell *matCellDef="let envelope"> {{ envelope.statusLastUpdated | localizedDate }} </td>
            </ng-container>
            <ng-container matColumnDef="view">
              <th mat-header-cell *matHeaderCellDef [attr.aria-label]="'common.labels.rowActions' | transloco">&nbsp;</th>
              <td mat-cell *matCellDef="let envelope">
                <button mat-icon-button color="accent" (click)="viewEnvelope(envelope, false)"
                  [attr.aria-label]="'hubReportsGrid.viewEnvelope' | transloco">
                  <mat-icon>graph_5</mat-icon>
                </button>
                <button mat-icon-button color="accent" (click)="viewEnvelope(envelope, true)"
                  [attr.aria-label]="'hubReportsGrid.viewEnvelopeInNewTab' | transloco">
                  <mat-icon>open_in_new</mat-icon>
                </button>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
            <tr mat-row *matRowDef="let envelope; columns: columnsToDisplay;" class="expandable-table-row"
              [class.example-expanded-row]="_expandedEnvelope === envelope"
              (click)="_expandedEnvelope = _expandedEnvelope === envelope ? null : envelope" tabindex="0" (keydown.enter)="_expandedEnvelope = _expandedEnvelope === envelope ? null : envelope">
            </tr>
          </table>
          }
          <!-- End of hub reports table-->
          <!-- Message while loading (show only if data.length is 0 and loading) -->
          @if (((this.repo.loading$ | async) ?? false) && data.length === 0) {
          <div class="padding center padding-top-bottom-50">
            &nbsp;
          </div>
          }
          <!-- Paginator for the bottom -->
          <div class="spacer-small"></div>
          @if (data.length > 0) {
          <mat-paginator [pageSize]="this.repo.pageSize$ | async" [length]="this.repo.resourceCount$ | async"
            [pageIndex]="this.repo.pageNum$ | async" [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons="true"
            (page)="page($event)"></mat-paginator>
          }
          <!-- End of paginator for the bottom -->
        </div>
        }
        <!-- End of main orders table-->
        <!-- Spinner (shows over entire card) -->
        @if (repo.loading$ | async) {
        <div class="loading-spinner-overlay">
          <mat-spinner></mat-spinner>
        </div>
        }
        <!-- End of spinner -->
        <lib-list-issue [repo]="this.repo" [data]="data"></lib-list-issue>
      </div>
      }
      <!-- End of container div for everything -->
    </mat-card-content>
  </mat-card>
</div>